import { Route, Routes } from 'react-router-dom';

import { useAuthentication } from 'hooks/api/useAuthentication';

import { AuthForgotPassword } from 'views/Auth/ForgotPassword';
import { AuthLogin } from 'views/Auth/Login';
import { AuthResetPassword } from 'views/Auth/ResetPassword';
import { Invite } from 'views/Auth/Invite/Invite';
import { ConfirmRing } from 'views/Register/ConfirmRing';
import { Register } from 'views/Register/Register';
import { RingBind } from 'views/Register/RingBind';
import { RingExistingAccount } from 'views/Register/RingExistingAccount';
import { SamlReturn } from 'views/Auth/SamlReturn';
import { VerifyEmail } from 'views/Auth/VerifyEmail';
import { Welcome } from 'views/Register/Welcome';

import { Loader } from 'components/Loader/Loader';

import { Root } from './Root';

export function RootContainer() {
  const { isLoading: isAuthenticating } = useAuthentication();

  if (isAuthenticating) {
    return <Loader text="Authenticating..." />;
  }

  return (
    <Routes>
      <Route path="*" element={<Root />} />

      {/* Auth routes */}
      <Route path="/register" element={<Register />} />
      {/* One-way Ring account linking landing (Ring redirects here with ?nonce=&time=). */}
      <Route path="/ring/link" element={<Register />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/welcome" element={<Welcome />} />
      <Route path="/confirm-ring" element={<ConfirmRing />} />
      {/* One-way Ring linking for a returning user (no signup runs, so Root routes here). */}
      <Route path="/ring/bind" element={<RingBind />} />
      <Route path="/ring-existing-account" element={<RingExistingAccount />} />
      <Route path="/login" element={<AuthLogin />} />
      <Route path="/forgot-password" element={<AuthForgotPassword />} />
      <Route path="/reset-password" element={<AuthResetPassword />} />
      <Route path="/saml_return" element={<SamlReturn />} />
      <Route path="/invite/*" element={<Invite />} />
    </Routes>
  );
}
